<template>
    <div ref="chartContainer">
        <highcharts v-if="Object.keys(chartData).length" :options="chartData" ref="chart" />
    </div>
</template>
<script>
export default {
    name: 'ThinPieChart',
    data() {
        return {
            chartData: {},
            resizeObserver: null
        }
    },
    props: {
        rawData: {
            /* 
                It receives data prop like so

                [{
                    name: 'Series Name such as Sentiments',
                    colorByPoint: true,
                    data: [{
                        name: 'Slice Name such as Positive Sentiments',
                        y: Number,
                        color: '#065559'
                    }, {
                        name: 'Slice Name such as Negative Sentiments',
                        y: Number,
                        color: '#9B1C1C'
                    }]
                }]
            
            */

            type: Array,
            required: true
        },
        innerSize: String, // '80%'
        noTotalText: Boolean, //default fallback - false, pass it true as prop if you do not want to show total in the mid of the pie.
        legendVerticalAlign: String,
        legendHorizontalAlign: String,
        formatLegend: {
            type: Boolean,
            default: true
        },
        dataLabel: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.plotChart();

            this.resizeObserver = new ResizeObserver(() => {
                this.resizeChart();
            });

            this.resizeObserver.observe(this.$refs.chartContainer);
        })
    },
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    },
    watch: {
        rawData: {
            handler() {
                this.plotChart();
            },
            deep: true
        }
    },
    methods: {
        resizeChart() {
            if (this.$refs.chart.chart) {
                this.$refs.chart.chart.reflow();
            }
        },
        formatNumber(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        plotLegend() {
            let self = this;

            let legend = {
                verticalAlign: self.legendVerticalAlign || 'bottom',
                align: self.legendHorizontalAlign || 'center',
                layout: 'vertical',
                symbolHeight: 10,
                itemStyle: {
                    fontSize: '14px',
                    textTransform: 'capitalize',
                    fontWeight: 400,
                    fontFamily: "Poppins"
                },
            }

            if (self.formatLegend) {
                legend = {
                    ...legend,
                    itemStyle: {
                        fontSize: '16px',
                        textTransform: 'capitalize'
                    },
                    useHTML: true,
                    labelFormatter: function () {
                        return `
                        <div style="width: 250px; display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px">
                            <span style="font-family: 'Poppins', sans-serif; font-weight: 400; color: #5e5e5e; text-align: center; word-wrap: break-word">
                                ${this.name}
                            </span> 
                            <span style="font-family: 'Poppins', sans-serif; text-align: right;">
                                ${self.formatNumber(this.y)}
                            </span>
                        </div>`
                    }
                }
            }

            return legend;
        },
        plotDataLabel() {
            if (this.dataLabel) {
                return {
                    enabled: true,
                    distance: -40,
                    format: "{point.percentage:.1f} %",
                    style: {
                        fontSize: 12,
                    },
                }
            }
            return {
                enabled: false
            }
        },
        plotChart() {
            let self = this;

            this.chartData = {
                chart: {
                    type: 'pie',
                    events: {
                        load: function () {
                            if (self.noTotalText) return;

                            const total = this.series[0].data.reduce((sum, point) => sum + point.y, 0);
                            const chart = this;

                            chart.renderer.text(`<span style="color: #5E5E5E; font-size: 16px; font-family: 'Poppins', sans-serif; text-align: center">Total</span>` + '<br />' + `<span style="font-size: 20px; font-family: 'Poppins', sans-serif; font-weight: 500">${self.formatNumber(total)}</span>`, chart.plotLeft + chart.plotWidth / 2.2, chart.plotTop + chart.plotHeight / 2.1)
                                .attr({
                                    zIndex: 5
                                })
                                .add();
                        }
                    }
                },
                title: {
                    text: ''
                },
                exporting: {
                    enabled: false,
                },
                plotOptions: {
                    pie: {
                        innerSize: self.innerSize || '80%',
                        dataLabels: self.plotDataLabel(),
                        showInLegend: true,
                    }
                },
                series: self.rawData,
                tooltip: {
                    enabled: false
                },
                legend: self.plotLegend(),
                credits: {
                    enabled: false
                }
            }
        }
    }
}
</script>